<template>
  <span :class="['proa-tool-icon', { 'active': active, 'no-sm-margin': noSmMargin }]">
    <img :src="src"/>
  </span>
</template>

<script>
export default {
  name: 'ProaToolIcon',
  props: {
    src: String,
    active: Boolean,
    noSmMargin: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.proa-tool-icon {
  display: inline-block;
  cursor: pointer;
  width: 26px;
  height: 26px;
  border-radius: 4px;
  margin-right: 10px;

  &.no-sm-margin {
    margin-right: 0;

    @include mq(md) {
      margin-right: 10px;
    }
  }

  &:hover, &.active {
    background-color: $light-gray-color;
  }

  img {
    margin: 3px;
    width: 20px;
    height: 20px;
  }
}
</style>
